<script setup lang="ts">
import { useError } from '~/infrastructure';

const { showError } = useError();
showError({ statusCode: '404', statusMessage: 'page.404.title' });
</script>
